import React from 'react';

function Button({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      {...otherProps}
    >
      <rect x=".65" y="7.65" width="22.7" height="8.7" rx="1.35" />
      <path d="M6 12h12" />
    </svg>
  );
}

export default Button;
